const categoryBenefitsMap = {
  'Equity Potential': { icon: '📈', label: 'Equity Potential' },
  'Formal Roles': { icon: '💼', label: 'Formal Roles' },
  'Compensation Potential': { icon: '💰', label: 'Compensation Potential' },
  'Board Member Discount': { icon: '📈', label: 'Board Member Discount' },
  'Complimentary Product': { icon: '📈', label: 'Complimentary Product' },
  'Warm Intro Reward': { icon: '🏆', label: 'Warm Intro Reward' },
  'Referral Bonus': { icon: '🏆', label: 'Referral Bonus' },
  '$1k Golden Idea Bonus': { icon: '💰', label: '$1k Golden Idea Bonus' },
  '1% Equity Pledge': { icon: '📈', label: '1% Equity Pledge' },
  'Executive Networking': {
    icon: '🤝',
    label: 'Executive Networking',
  },
  'Video Updates': { icon: '🎥', label: 'Video Updates' },
  'Direct Connect': { icon: '💬', label: 'Direct Connect' },
  'Advisory Board Affiliation': {
    icon: '💼',
    label: 'Advisory Board Affiliation',
  },
  'Professional Exposure': { icon: '🚀', label: 'Professional Exposure' },
  'Advisor Shoutout': { icon: '📣', label: 'Advisor Shoutout' },
  'Executive Endorsement': { icon: '📝', label: 'Executive Endorsement' },
  'Board Certificate': { icon: '📝', label: 'Board Certificate' },
  'Advisor Rate Opportunity': { icon: '💰', label: 'Advisor Rate Opportunity' },
  'Board Meeting Speaker Recognition': {
    icon: '💬',
    label: 'Board Meeting Speaker Recognition',
  },
  'FavorBonds Grant ($300 Value)': {
    icon: '💲',
    label: 'FavorBonds Grant ($300 Value)',
  },
  '1-Year Board Member Plaque': {
    icon: '🏆',
    label: '1-Year Board Member Plaque',
  },
  '3-Year Featured Advisor Award': {
    icon: '🏆',
    label: '3-Year Featured Advisor Award',
  },
  Perks: { icon: '🎁', label: 'Perks' },
};

module.exports = categoryBenefitsMap;
